"use client";

import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { refreshAccount, useAuthCallFunction } from "@web/lib/auth";
import { useRequestErrors } from "@web/lib/clientData";
import { useState } from "react";

const stripePromise = loadStripe(
  "pk_live_51T5lt1Benj2OLbVgCJivXaWD3xqLVx173mUmFTSy8gaQF079pJxRR5ehYqKNp6TvBewz0V6wFnnOPnf2BSZkNcKw00RYnT0oq3",
);

export function CardForm() {
  const elements = useElements();
  const stripe = useStripe();
  const { push } = useRequestErrors();
  const [valid, setValid] = useState(false);
  const authCall = useAuthCallFunction();
  return (
    <div className="flex items-center text-white md:max-w-[400px]">
      <div className="flex-grow">
        <CardElement
          onChange={(e) => setValid(e.complete)}
          options={{
            style: {
              base: {
                color: "#ffffff", // Change text color to white
                fontSize: "16px", // Set font size if needed
                fontFamily: '"Roboto", sans-serif', // Optionally change font family
                "::placeholder": {
                  color: "#c4c4c4", // Change placeholder color if needed
                },
              },
            },
          }}
        />
      </div>
      <button
        className="text-lg bg-[#121212] rounded-lg text-white py-1 px-3 hover:opacity-90 disabled:opacity-20 focus:outline"
        onClick={async () => {
          try {
            if (!stripe || !elements) {
              return;
            }
            const { error, paymentMethod } = await stripe.createPaymentMethod({
              type: "card",
              card: elements.getElement(CardElement) as any,
            });
            if (error) {
              throw error.message;
            }
            const cardId = paymentMethod?.id;
            await authCall("PUT", `payment/card/${cardId}`).catch((e) => {
              throw e.message;
            });
            await authCall("POST", `payment/card/${cardId}/default`).catch(
              (e) => {
                throw e.message;
              },
            );

            refreshAccount();
          } catch (error) {
            push({ error });
          }
        }}
        type="submit"
        disabled={!stripe || !valid}
      >
        +
      </button>
    </div>
  );
}

export default function StripeAddPayment() {
  return (
    <Elements stripe={stripePromise}>
      <CardForm />
    </Elements>
  );
}
